import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'ui';
import BeigeHeaderContent from 'ui/layouts/BeigeHeaderContent';
import { childrenType } from 'utils/types';

import s from './CategoryPageLayout.module.scss';

const cx = cn.bind(s);

const CategoryPageLayout = ({
  children,
  className,
  title,
  titleClassName,
  topSpacingClassName,
  headerTitle,
  headerInfo,
  headerNotice,
  headerContent,
  headerClassName,
  headerInfoColProps,
  hasCircles,
  ...attrs
}) => (
  <div className={cx('categoryPageLayout', className)} {...attrs}>
    <BeigeHeaderContent
      title={headerTitle}
      mainText={headerInfo}
      className={headerClassName}
      headerInfoColProps={headerInfoColProps}
      hasCircles={hasCircles}
    >
      { headerNotice ? (
        <div className={cx('headerNoticeWrapper')}>
          <p className={cx('headerNotice')}>
            {headerNotice}
          </p>
        </div>
      ) : null}
      {headerContent}
    </BeigeHeaderContent>
    <div className={cx('headerTopSpacing', topSpacingClassName)}>
      {title && (
        <Container>
          <Row>
            <Col>
              <h2
                className={cx(
                  titleClassName,
                  'title',
                  'tp-mobile-header-2 md:tp-tablet-header-2 xl:tp-header-2'
                )}
              >
                {title}
              </h2>
            </Col>
          </Row>
        </Container>
      )}
      {children}
    </div>
  </div>
);

CategoryPageLayout.propTypes = {
  children: childrenType,
  className: PropTypes.string,
  topSpacingClassName: PropTypes.string,
  title: PropTypes.string,
  headerTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  headerInfo: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  headerClassName: PropTypes.string,
  headerContent: PropTypes.element,
  hasCircles: PropTypes.bool,
};

export default CategoryPageLayout;
